function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ButtonDropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { kebabCase } from 'lodash';
import { v4 as uuid } from 'uuid';
import entityComposition from '../common/classes/entityComposition';
import IssueExportModal from './issueExportModal';
import AssignmentModal from './assignmentModal';
import Icon from '../common/containers/icon';
const exportActions = [{
  text: 'Export: New',
  icon: 'file-circle-plus'
}, {
  text: 'Export: Existing',
  icon: 'file-export'
}];
const baseActions = [{
  text: 'Assign',
  icon: 'user-plus'
}, {
  text: 'Delete',
  icon: 'trash'
}];
const IssuesBulkActions = ({
  employeeModalAssignIndexQuery,
  employeeModalAssignActions: {
    serverFilter
  },
  issue: {
    selected
  },
  issueActions: {
    serverSaveAssignments,
    serverDeleteIssues
  },
  issueAssignmentModalAssign: {
    indexQuery,
    list: issueAssignments
  },
  reportTypeIssueBulkExport: {
    list: reportTypesList,
    indexQuery: reportTypeIndexQuery
  },
  reportTypeIssueBulkExportActions: {
    serverFilter: reportTypeServerFilter
  },
  issueAssignmentModalAssignActions,
  issueExportReportTypes: _issueExportReportTypes = [],
  notificationActions
}) => {
  var _issueExportReportTyp;
  const [toggle, setToggle] = useState(false);
  const [createNewReport, setCreateNewReport] = useState(false);
  const [showExportReportModal, setShowExportReportModal] = useState(false);
  const [assignmentModalIsOpen, setAssignmentModalIsOpen] = useState(false);

  // build the actions menu dependent upon wether there's an export report available
  const actions = _issueExportReportTypes.length ? [...baseActions, ...exportActions] : baseActions;

  // Load reportTypes for the selector
  useEffect(() => {
    // (currently) the only issue export report type
    // hardcoded at the moment, but in theory this could be an option picker un-to itself
    reportTypeServerFilter({
      reportTypeIdentifiers: ['issueExportReport']
    }, reportTypeIndexQuery);
  }, [reportTypesList, reportTypeIndexQuery, reportTypeServerFilter]);
  const openAssignmentModal = useCallback(async () => {
    await issueAssignmentModalAssignActions.serverFilter({
      issue: selected.map(id => ({
        id
      }))
    }, indexQuery, false);
    await serverFilter({
      issue: selected,
      status: 1
    }, employeeModalAssignIndexQuery, false);
    setAssignmentModalIsOpen(true);
  }, [selected, issueAssignmentModalAssignActions, serverFilter, employeeModalAssignIndexQuery, indexQuery, setAssignmentModalIsOpen]);
  const handleAssignmentSave = useCallback((employeeAssignments, removals) => {
    const removalAssignments = removals.map(userID => ({
      userID,
      remove: true
    }));
    const additiveAssignments = employeeAssignments.map(userID => ({
      userID,
      remove: false
    }));
    const allUpdates = removalAssignments.concat(additiveAssignments);
    const newAssignments = [];
    selected.forEach(issueID => {
      allUpdates.forEach(update => {
        newAssignments.push(_objectSpread(_objectSpread({}, update), {}, {
          issueID
        }));
      });
    });
    serverSaveAssignments(uuid(), newAssignments);
    setAssignmentModalIsOpen(false);
  }, [selected, serverSaveAssignments]);
  const handleButtonSelect = useCallback(currentAction => {
    if (currentAction === 'Assign') openAssignmentModal();
    if (currentAction === 'Export: Existing' || currentAction === 'Export: New') {
      setCreateNewReport(currentAction.endsWith('New'));
      setShowExportReportModal(true);
    }
    if (currentAction === 'Delete') {
      notificationActions.info({
        message: `Are you sure you wish to delete ${selected.length} issue${selected.length > 1 ? 's' : ''}?`,
        rightButtonLabel: 'Delete',
        rightButtonAction: () => serverDeleteIssues(selected),
        leftButtonLabel: 'Keep',
        id: 'annotation_delete_warning'
      }, {
        autoClose: false
      });
    }
  }, [openAssignmentModal, selected, serverDeleteIssues, notificationActions]);
  return /*#__PURE__*/React.createElement(ButtonDropdown, {
    isOpen: toggle,
    id: "issueBulkActions",
    toggle: () => setToggle(!toggle)
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    disabled: selected.length === 0,
    caret: true
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    glyph: "bolt"
  }), " Actions")), /*#__PURE__*/React.createElement(DropdownMenu, null, actions.map(action => /*#__PURE__*/React.createElement(DropdownItem, {
    key: action.text,
    className: `t-iba-button-${kebabCase(action.text)}`,
    disabled: false,
    onClick: () => handleButtonSelect(action.text)
  }, /*#__PURE__*/React.createElement(Icon, {
    style: {
      width: '10%',
      marginRight: '5px'
    },
    glyph: action.icon
  }), " ", action.text))), /*#__PURE__*/React.createElement(AssignmentModal, {
    assignments: issueAssignments,
    isOpen: assignmentModalIsOpen,
    closeModal: () => setAssignmentModalIsOpen(!assignmentModalIsOpen),
    saveAssignments: handleAssignmentSave,
    selected: selected,
    entity: "issue"
  }), /*#__PURE__*/React.createElement(IssueExportModal, {
    toggle: () => setShowExportReportModal(!showExportReportModal),
    createNewReport: createNewReport,
    isOpen: showExportReportModal,
    selected: selected
    // down the road, this could be 'selected rpoert type'
    ,
    reportTypeID: (_issueExportReportTyp = _issueExportReportTypes[0]) === null || _issueExportReportTyp === void 0 ? void 0 : _issueExportReportTyp.id
  }));
};
IssuesBulkActions.propTypes = {
  employeeModalAssignIndexQuery: PropTypes.shape({}).isRequired,
  employeeModalAssignActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired,
  issue: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    selected: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  issueActions: PropTypes.shape({
    serverFilter: PropTypes.func,
    serverSaveAssignments: PropTypes.func,
    serverDeleteIssues: PropTypes.func
  }).isRequired,
  issueAssignmentModalAssign: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  issueAssignmentModalAssignActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  issueExportReportTypes: PropTypes.arrayOf(PropTypes.shape({})),
  reportTypeIssueBulkExport: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  reportTypeIssueBulkExportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { IssuesBulkActions as TestIssuesBulkActions };
export default entityComposition(IssuesBulkActions, ['issue', 'issueAssignmentModalAssign', 'reportTypeIssueBulkExport', 'jobIssueBulkExport'], {
  employeeModalAssignIndexQuery: state => state.employeeModalAssign.indexQuery,
  issueExportReportTypes: state => state.reportTypeIssueBulkExport.list
}, ['notification', 'employeeModalAssign']);